import React, { useState } from "react";
import { Form, Button, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaArrowRight } from "react-icons/fa";
import { userServices } from "../../APIServices/userServices";

const LoginPage = () => {
  const [loader, setLoader] = useState(false);
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const login = async () => {
    setLoader(true);
    let userData = {
      email,
      password,
    };
    let data = await userServices.login(userData);
    if (data?.statusCode === 200) {
    }
    setLoader(false);
  };
  return (
    <>
      <Card
        className="p-4 bg-white shadow-md border"
        style={{ borderRadius: "15px", width: 450 }}
      >
        <Card.Body>
          <h3 className="text-center mb-4 fw-bold">Login ✨</h3>

          <Form.Group className="mb-4 floating-group">
            <Form.Control
              type="email"
              placeholder=""
              className="interactive-input"
              required
              onChange={(e) => setEmail(e.target.value)}
              value={email}
            />
            <Form.Label>Email *</Form.Label>
          </Form.Group>
          <Form.Group className="mb-4 floating-group">
            <Form.Control
              type="password"
              placeholder=""
              className="interactive-input"
              required
              onChange={(e) => setPassword(e.target.value)}
              value={password}
            />
            <Form.Label>Password *</Form.Label>
          </Form.Group>
          <Form.Group className="mb-4">
            <Form.Check type="checkbox" label="Remember me" />
          </Form.Group>
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="mb-3"
          >
            <Button
              onClick={login}
              className="w-100 py-2 fw-bold btn-gradient"
              disabled={loader}
            >
              Login <FaArrowRight />
            </Button>
          </motion.div>
        </Card.Body>
      </Card>
    </>
  );
};

export default LoginPage;
